import { CategoryAreaPinComponent, PinComponent } from '@lessonup/pins-shared';

/** Determines whether the pin component has a locked layout. */
export function isPinComponentLocked(pinComponent: PinComponent): boolean {
  return pinComponent.settings.lockLayout ?? false;
}

export function getPinComponentBorderStyle(pinComponent: CategoryAreaPinComponent) {
  return pinComponent.settings.borderStyle ?? 'solid';
}
